import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 px-6 py-16 lg:px-12" data-testid="site-footer">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Link to="/" data-testid="footer-logo" className="text-3xl font-medium tracking-tight">
            Haus Ov Harii
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#9EA3B0]">
            One house, two disciplines: brand and campaign design for institutions;
            illustration and identity for culture.
          </p>
        </div>
        <nav className="md:col-span-3" aria-label="Footer">
          <p className="eyebrow mb-4">Routes</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link data-testid="footer-corporate-link" className="text-[#9EA3B0] transition-colors hover:text-white" to="/corporate">Corporate</Link>
            <Link data-testid="footer-creative-link" className="text-[#9EA3B0] transition-colors hover:text-white" to="/creative">Creative</Link>
            <Link data-testid="footer-about-link" className="text-[#9EA3B0] transition-colors hover:text-white" to="/about">About</Link>
            <Link data-testid="footer-contact-link" className="text-[#9EA3B0] transition-colors hover:text-white" to="/contact">Contact</Link>
          </div>
        </nav>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4">Elsewhere</p>
          <div className="flex flex-col gap-2 text-sm">
            <a data-testid="footer-linkedin-link" className="text-[#9EA3B0] transition-colors hover:text-white" href="https://www.linkedin.com/in/harriet-griffiths-jones-51a155126/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <Link data-testid="footer-enquire-link" className="text-[#9EA3B0] transition-colors hover:text-white" to="/contact">Send an enquiry</Link>
          </div>
        </div>
      </div>
      <div className="mt-16 flex items-center justify-between border-t border-white/10 pt-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#616775]">
          © 2026 Haus Ov Harii · Worldwide
        </p>
        <button
          data-testid="back-to-top-button"
          onClick={() => window.scrollTo(0, 0)}
          className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#616775] transition-colors hover:text-white"
          aria-label="Back to top"
        >
          Top <ArrowUp size={14} />
        </button>
      </div>
    </footer>
  );
}
